import { XStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

export function TabButton({
  label,
  active,
  count,
  onClick,
}: {
  label: string;
  active: boolean;
  count?: number;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className={cn(
        'py-2 text-sm transition-colors relative',
        active
          ? 'text-foreground'
          : 'text-foreground-muted hover:text-foreground-subtle'
      )}
      onClick={onClick}
    >
      <XStack className="items-center gap-1.5">
        <span>{label}</span>
        {count !== undefined && (
          <span className="text-xs text-foreground-muted tabular-nums">
            {count}
          </span>
        )}
      </XStack>
      {active && (
        <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-foreground rounded-full" />
      )}
    </button>
  );
}
